// 공통 상수 처리
const DEFAULT_PAGE_SIZE = 10;

const STORE_KEYS = {
	AUTH: "GNsb",
	TERMS: "g4vL",
};

export { DEFAULT_PAGE_SIZE, STORE_KEYS };
